<template>
  <aside class="flex flex-col w-fit py-5 px-0 overflow-y-auto">
    <template v-for="(link, idx) in links" :key="idx">
      <router-link
          v-if="link.route"
          :to="{ name: link.route }"
          class="flex flex-row items-center gap-4 px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-800 text-xs lg:rounded-none rounded-md"
          :class="link.route === $route.name ? 'bg-slate-200 dark:bg-slate-700':''"
      >
        <aside-link
            :label="link.label"
            :route="link.route"
            :icon="link.icon"
            :count="link.count ?? 0"
        />
      </router-link>
    </template>
  </aside>
</template>

<script>

import AsideLink from "./asideLink.vue";
import Sidebar from 'primevue/sidebar';
import Menu from 'primevue/menu';
import serviceRepository from "#repositories/serviceRepository";

export default {
  name: "HomeAside",
  components: {
    Menu,
    Sidebar,
    AsideLink
  },
  async mounted() {
    this.links = [
      {
        route: 'ServicesInbox',
        icon: 'fa-solid fa-store',
        label: 'Caixa de entrada',
        count: (await serviceRepository.getServicesInbox()).meta.total
      },
      {
        route: this.$can('service-outbox-index') ? 'ServicesOutbox' : '',
        icon: 'fa-solid fa-box-open',
        label: 'Caixa de saída'
      },
      {
        route: this.$can('execute-multiple-procedures') ? 'MultipleExecution' : '',
        icon: 'fa-solid fa-cubes',
        label: 'Execução Múltipla',
      },
      {
        route: this.$can('services.source_services.index') ? 'SourceServicesIndex':'',
        icon: 'fa-book',
        label: 'Serviços'
      },
      {
        route: this.$can('services.source_service_categories.index') ? 'SourceServicesCategories':'',
        icon: 'fa-book',
        label: 'Categorias de serviços'
      },
      {
        route: this.$hasRole('admin') ? 'Organizations':'',
        icon: 'fa-solid fa-building',
        label: 'Organizações'
      },
      {
        route: this.$hasRole('admin') ? 'OrganizationsCategories':'',
        icon: 'fa-solid fa-building',
        label: 'Categorias de organizações'
      },
      {
        route: this.$hasRole('admin') ? 'Collaborators':'',
        icon: 'fa-solid fa-handshake',
        label: 'Colaboradores'
      },
      {
        route: this.$hasRole('admin') ? 'CollaboratorsFunctions':'',
        icon: 'fa-solid fa-handshake',
        label: 'Funções'
      },
      {
        route: this.$can('people.index') ? 'PeopleIndex':'',
        icon: 'fa-solid fa-people-group',
        label: 'Pessoas'
      },
      {
        route: this.$hasRole('admin') ? 'AccessProfile':'',
        icon: 'fa-solid fa-gear',
        label: 'Perfis'
      },
      {
        route: this.$can('users.index') ? 'Users':'',
        icon: 'fa-solid fa-gear',
        label: 'Usuários'
      },
      {
        route: this.$can('dashboards.index') ? 'Dashboards':'',
        icon: 'fa-solid fa-chart-line',
        label: 'Dashboards'
      },
      {
        route: this.$can('newsletter.messages.index') ? 'MessageIndex' : '',
        icon: 'fa-solid fa-message',
        label: 'Mensagens'
      },
    ];

  },
  data() {
    return {
      links: [],
      hover: false
    }
  }
};
</script>
